<template src="./Index.html">
</template>


<script>
import AddView from './actions/Add.vue';
import EditView from "./actions/Edit.vue";
import DetailsView from "./actions/Details.vue";

export default {
  components: {
    AddView,
    EditView,
    DetailsView,
  },
  created() {
    this.getAll();
  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.$store.state.paymentAccounts.totalItems / this.filters.pageSize
      );
    },

    paymentAccounts() {
      return this.$store.state.paymentAccounts.paymentAccounts;
    },

  },

  data() {
    return {
      permissions: this.$settingPermissions.paymentAccountsPermissions,

      view: 0,
      dialog: false,
      dialogType: null,
      dialogMessage: "",
      formDialog: false,

      filters: {
        page: 1,
        pageSize: 10,
        accountName: null,
      },

      headers: [
        { text: 'اسم الحساب ', value: 'accountName' },
        { text: 'معرف الحساب ', value: 'incomeAccount' },
        { text: "الحالة", value: "status", sortable: false },
        { text: 'منشأ بواسطة  ', value: 'createdBy' },
        { text: 'تاريخ الانشاء  ', value: 'createdOn' },

        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
      itemId: 0,
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("paymentAccounts/getAll", this.filters);
    },

    addItem() {
      this.view = 1;
    },

    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
    },

    editItem(item) {
      this.itemId = item.id;
      this.view = 2;
    },

    back() {
      this.view = 0;
    },
    // --------------------------form dilog ------------------------------- //
    showDialog(item, type) {
      switch (type) {
        case "delete":
          this.dialogMessage = "هل انت متأكد من رغبتك حذف البيانات";
          break;
        case "lock":
          this.dialogMessage = "هل انت متأكد من رغبتك تجميد البيانات";
          break;
        case "unlock":
          this.dialogMessage = "هل انت متأكد من رغبتك تفعيل البيانات";
          break;
      }
      this.dialogType = type;
      this.itemId = item.id;
      this.dialog = true;
    },

    confirmDialog() {
      this.$store.dispatch(`paymentAccounts/${this.dialogType}`, this.itemId);
      this.cancelDialog();
    },

    cancelDialog() {
      this.dialog = false;
      this.itemId = 0;
      this.dialogMessage = "";
      this.dialogType = null;
    },
  },
};
</script>

<style scoped></style>